// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1785":"55a879d5","4143":"55a879d5","4264":"55a879d5","5260":"55a879d5","6926":"55a879d5","7343":"55a879d5","9330":"55a879d5"}[chunkId] + ".chunk.css";
};